import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { TableComponent } from 'src/app/back-office/components/table/table.component';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';
import { ClassifySettingComponent } from 'src/app/back-office/components/edit-project/project-editing/classify-setting/classify-setting.component';
@Component({
  selector: 'app-project-classify',
  templateUrl: './project-classify.component.html',
  styleUrls: ['./project-classify.component.scss', '../../../../components/table/table.component.scss']
})
export class ProjectClassifyComponent  extends TableComponent{
  constructor(
    private elRef:ElementRef,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private helper: HelperModule,
    private sharedService: SharedService,
    public dialog: MatDialog,
    public sanitizer: DomSanitizer) {
      super(sanitizer);
  }
  @Output() outputEmiter = new EventEmitter<any>();
  @Input() userInfos!: { [key: string]: any };
  @Input() classifyData!: { [key: string]: any }[];
  @Input() projectInfos!: { [key: string]: any };
  @Input() platformInfos!: any;

  ngOnInit() {
    this.setData();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['classifyData'] && !changes['classifyData'].firstChange) {
      this.setData();
    }
  }
  setData(){
    if(this.classifyData && this.classifyData.length){
      this.dataSource = this.classifyData.map((row:any) => {
        row['year_name'] = [4, 5, 7].includes(row['id_section'])  ? ((row['id_content_learning'] ?? '')  + ' ' + (row['content_name'] ?? '')) : (row['year'] ?? '');
        row['type_chapter'] = row['id_section'] == 4  ? (row['chapter'] ?? '')  : ((row['id_content_replace']? `R:${row['id_content_replace']}`: '') + ' ' +(row['id_content_subject'] ?? '') + ' ' + (row['type'] ?? '')); 
        row['state_format'] = this.buildTagsHtml(row.state),
        row['active_format'] = this.buildTagsHtml(row.active.toString())
        return row;
      });
      
      this.showedRows = this.dataSource;
    }
    
  }
  contentOption(rowInfos:{ [x:string]: any },){
    let duplicateRows = this.classifyData.filter((row: any)=> row.id_content_duplicate == rowInfos['id_content'] && row.source == 'content')
    const dialogRef = this.dialog.open(ClassifySettingComponent, {
      width: '70%',
      position: {top: '30px' },
      data: {is_multiple: false, selected_rows: [rowInfos], duplicate_rows: duplicateRows, user_infos: this.userInfos, platform_infos: this.platformInfos, project_infos: this.projectInfos}
    });
    dialogRef.afterClosed().subscribe((response:any) => {
      if(response.status) this.setUpdatedContent(response.contents, this.platformInfos.key);
    });
  }
  contentsSetting(){
    let selectedRows = this.selectRows();
    if(selectedRows.length){
      const dialogRef = this.dialog.open(ClassifySettingComponent, {
        width: '70%',
        position: {top: '30px' },
        data: {is_multiple: true, selected_rows: selectedRows, duplicate_rows: [], user_infos: this.userInfos, platform_infos: this.platformInfos, project_infos: this.projectInfos}
      });
      dialogRef.afterClosed().subscribe((response:any) => {
        if(response.status) this.setUpdatedContent(response.contents, this.platformInfos.key);
        if(response.action == 'build_selected_auto_edition') this.outputEmiter.emit({action: response.action, content_ids: selectedRows.map((element)=> element.id_content)});
      });
    }else this.helper.showToast('Select contents first...');
  }
  setWaiting(value:any){
    this.sharedService.sendData({in_progress: value});
  }
  toggleRow(row:any, clickedElm:any, rowTab:any){
    let toExpand = true;
    for (var tdTab of rowTab.querySelectorAll('.to_skip_element')){
      if(tdTab.contains(clickedElm)){
        toExpand = false;
        break;
      }
    }
    if(toExpand){
      row['expanded'] =! row['expanded'];
    }
  }
  applyFilterLocal(element:any, column:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applyFilter(element.value, column);
    this.cdRef.detectChanges();
  }
  applySortLocal(element:any, column:string, type:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applySort(element, column, type);
    this.cdRef.detectChanges();
  }
  selectAllOption(element: any){
    this.selectAll(element);
    this.cdRef.detectChanges();
  }
  
}
